var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 179,
    viewBox: "0 0 401 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.377 160.633L114.458 164.234C114.089 164.69 114.089 165.341 114.458 165.796L117.377 169.398L113.78 166.476C113.325 166.106 112.674 166.106 112.22 166.476L108.623 169.398L111.541 165.796C111.91 165.341 111.91 164.69 111.541 164.234L108.623 160.633L112.22 163.555C112.674 163.925 113.325 163.925 113.78 163.555L117.377 160.633Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126 165.016L113.613 165.629L113 178.031L112.387 165.629L100 165.016L112.387 164.402L113 152L113.613 164.402L126 165.016Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.681 18.3047L160.887 20.5183C160.66 20.7981 160.66 21.1987 160.887 21.4785L162.681 23.6922L160.47 21.8959C160.19 21.6689 159.79 21.6689 159.511 21.8959L157.3 23.6922L159.094 21.4785C159.321 21.1987 159.321 20.7981 159.094 20.5183L157.3 18.3047L159.511 20.1009C159.79 20.328 160.19 20.328 160.47 20.1009L162.681 18.3047Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.981 21L160.367 21.3771L159.99 29L159.614 21.3771L152 21L159.614 20.6229L159.99 13L160.367 20.6229L167.981 21Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236.751 20.8788L233.875 18L231 20.8788L233.875 23.7576L236.751 20.8788Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.751 62.8788L109.875 60L107 62.8788L109.875 65.7576L112.751 62.8788Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M279.751 154.879L276.875 152L274 154.879L276.875 157.758L279.751 154.879Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M289.377 51.1367L286.626 54.5311C286.279 54.9601 286.279 55.5743 286.626 56.0033L289.377 59.3977L285.987 56.6433C285.559 56.2952 284.945 56.2952 284.517 56.6433L281.126 59.3977L283.877 56.0033C284.225 55.5743 284.225 54.9601 283.877 54.5311L281.126 51.1367L284.517 53.891C284.945 54.2391 285.559 54.2391 285.987 53.891L289.377 51.1367Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M297.504 55.2669L285.83 55.8451L285.252 67.5337L284.675 55.8451L273 55.2669L284.675 54.6886L285.252 43L285.83 54.6886L297.504 55.2669Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7871 160.574C11.2218 160.574 11.5742 160.222 11.5742 159.787C11.5742 159.352 11.2218 159 10.7871 159C10.3524 159 10 159.352 10 159.787C10 160.222 10.3524 160.574 10.7871 160.574Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.32 114.641C139.602 114.641 140.641 113.602 140.641 112.32C140.641 111.039 139.602 110 138.32 110C137.039 110 136 111.039 136 112.32C136 113.602 137.039 114.641 138.32 114.641Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M361.32 5.64062C362.602 5.64062 363.641 4.60179 363.641 3.32031C363.641 2.03884 362.602 1 361.32 1C360.039 1 359 2.03884 359 3.32031C359 4.60179 360.039 5.64062 361.32 5.64062Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.587 49.3448L11.3164 47.0742L9.04581 49.3448L11.3164 51.6154L13.587 49.3448Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3164 38L11.6871 47.444H10.9458L11.3164 38Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3164 60.6315L11.6871 51.1875H10.9458L11.3164 60.6315Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6329 49.3159L13.189 48.9453V49.6866L22.6329 49.3159Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 49.3159L9.44397 48.9453V49.6866L0 49.3159Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M391.587 163.345L389.316 161.074L387.046 163.345L389.316 165.615L391.587 163.345Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M389.316 152L389.687 161.444H388.946L389.316 152Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M389.316 174.631L389.687 165.188H388.946L389.316 174.631Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M400.633 163.316L391.189 162.945V163.687L400.633 163.316Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M378 163.316L387.444 162.945V163.687L378 163.316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.a9cd0d2fee37d6a7eb98319241573600.svg";
export { ForwardRef as ReactComponent };